// this is proxy file so that babel inlines src/places.css into the css variable
// since it is not a commonjs file
import css from './src/places.css';

export default css;
